<template>
  <div>
    <strong>Note:</strong> This is only necessary if the event was previously marked as compliant by other logic.
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      id: String
    }
  };
</script>
